import type { FunctionComponent } from "react"

import Skeleton from "react-loading-skeleton"

import { Text } from "@jobteaser/spark/components/Text"

import styles from "./CardLoading.module.css"

export const CardLoading: FunctionComponent = () => {
  return (
    <div className={styles.main}>
      <aside>
        <Text variant="body2" className={styles.companyLogo}>
          <Skeleton />
        </Text>
        <Text variant="body2" className={styles.companyName}>
          <Skeleton />
        </Text>
      </aside>
      <div className={styles.jobAdInformations}>
        <Text variant="body2" className={styles.companyName}>
          <Skeleton />
        </Text>
        <div className={styles.jobAdTitle}>
          <Text variant="body2" className={styles.jobAdTitleFirstLine}>
            <Skeleton />
          </Text>
          <Text variant="body2" className={styles.jobAdTitleSecondLine}>
            <Skeleton />
          </Text>
        </div>
        <div className={styles.jobAdLowerInformations}>
          <div className={styles.flexContainer}>
            <Text variant="body2" className={styles.jobAdDurationLogo}>
              <Skeleton />
            </Text>
            <Text variant="body2" className={styles.jobAdDuration}>
              <Skeleton />
            </Text>
          </div>
          <div className={styles.flexContainer}>
            <Text variant="body2" className={styles.jobAdLocationLogo}>
              <Skeleton />
            </Text>
            <Text variant="body2" className={styles.jobAdLocation}>
              <Skeleton />
            </Text>
          </div>
        </div>
      </div>
      <div className={styles.jobAdStatus}>
        <Text variant="body2" className={styles.jobAdLike}>
          <Skeleton />
        </Text>
        <Text variant="body2" className={styles.jobAdTime}>
          <Skeleton />
        </Text>
      </div>
    </div>
  )
}
